import { AnimatedSection } from "../shared";
import { TokenomicsChart } from "./TokenomicsChart";
import { appStore } from "store";
import { ArrowRight } from "lucide-react";

export default function NewTokenomics() {
  const { currentRound } = appStore();
  const currentPrice = currentRound?.tokenPrice
    ? `$${currentRound.tokenPrice}`
    : "$0";

  const TOKEN_INFO = [
    { label: "Token Supply", value: "1B" },
    { label: "Ticker", value: "$ATTS" },
    {
      label: "Chain",
      value: "BNB",
      icon: `${process.env.PUBLIC_URL}/coins/bnb.png`,
    },
    { label: "Current Price", value: currentPrice },
    { label: "TGE Price", value: "$0.150" },
  ];
  return (
    <section className="py-12 md:py-16 px-6 relative overflow-hidden bg-[#f5f5f5]">
      <div className="max-w-7xl mx-auto w-full relative z-10">
        <AnimatedSection>
          <div className="mb-4">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-black/40 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-black/30 before:to-transparent">
              $ATTS token overview
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] text-black">
              $ATTS Tokenomics
            </h2>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.1}>
          <div className="bg-white border border-black/[0.08] rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              <TokenomicsChart />

              <div>
                <div className="flex items-center justify-between mb-6">
                  <h3 className="font-space-grotesk text-2xl font-bold text-black">
                    Token Info
                  </h3>
                  <a
                    href="https://docs.agnthub.ai/agnt.hub/tokenomics-and-token-utility"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-black/50 border border-black/[0.1] px-4 py-2 rounded-full hover:border-black/20 transition-colors no-underline flex items-center gap-1.5"
                  >
                    Detailed Tokenomics
                    <ArrowRight className="w-5 h-5 text-black/50" />
                  </a>
                </div>

                <div className="flex flex-col divide-y divide-black/[0.06]">
                  {TOKEN_INFO.map((row) => (
                    <div
                      key={row.label}
                      className="flex items-center justify-between py-4"
                    >
                      <span className="text-base text-black/50 font-medium">
                        {row.label}
                      </span>
                      <div className="flex items-center gap-2">
                        {row.icon && (
                          <img
                            src={row.icon}
                            alt=""
                            className="w-5 h-5 object-contain"
                          />
                        )}
                        <span className="font-space-grotesk text-lg font-bold text-black">
                          {row.value}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
